export const medicationFormList = [
  // { description: "aerosol", code: "c42887" },
  // { description: "aerosol, foam", code: "c42888" },
  // { description: "aerosol, metered", code: "c42960" },
  // { description: "aerosol, powder", code: "c42971" },
  { description: "aerosol, spray", code: "c42889" },
  // { description: "bar, chewable", code: "c42892" },
  // { description: "bead", code: "c42890" },
  // { description: "capsule", code: "c25158" },
  // { description: "capsule, coated", code: "c42895" },
  // { description: "capsule, coated pellets", code: "c42896" },
  // { description: "capsule, coated, extended release", code: "c42917" },
  // { description: "capsule, delayed release", code: "c42902" },
  // { description: "capsule, delayed release pellets", code: "c42904" },
  // { description: "capsule, extended release", code: "c42916" },
  // { description: "capsule, film coated, extended release", code: "c42928" },
  // { description: "capsule, gelatin coated", code: "c42936" },
  // { description: "capsule, liquid filled", code: "c42954" },
  // { description: "cellular sheet", code: "c100103" },
  // { description: "chewable gel", code: "c134876" },
  // { description: "cloth", code: "c60884" },
  // { description: "concentrate", code: "c60891" },
  // { description: "cream", code: "c28944" },
  // { description: "cream, augmented", code: "c60897" },
  // { description: "crystal", code: "c42901" },
  // { description: "disc", code: "c43525" },
  // { description: "douche", code: "c42679" },
  // { description: "dressing", code: "c42763" },
  // { description: "elixir", code: "c42912" },
  // { description: "emulsion", code: "c42913" },
  // { description: "enema", code: "c42915" },
  // { description: "extract", code: "c42929" },
  // { description: "fiber, extended release", code: "c60926" },
  // { description: "film", code: "c42932" },
  // { description: "film, extended release", code: "c42920" },
  // { description: "film, soluble", code: "c42984" },
  // { description: "for solution", code: "c60927" },
  // { description: "for suspension", code: "c60928" },
  // { description: "for suspension, extended release", code: "c60929" },
  // { description: "gas", code: "c42933" },
  // { description: "gel", code: "c42934" },
  // { description: "gel, dentifrice", code: "c42906" },
  // { description: "gel, metered", code: "c60930" },
  // { description: "globule", code: "c42937" },
  // { description: "granule", code: "c42938" },
  // { description: "granule, delayed release", code: "c42903" },
  // { description: "granule, effervescent", code: "c42909" },
  // { description: "granule, for solution", code: "c42939" },
  // { description: "granule, for suspension", code: "c42940" },
  // { description: "granule, for suspension, extended release", code: "c42921" },
  // { description: "gum, chewing", code: "c42894" },
  // { description: "implant", code: "c42942" },
  // { description: "inhalant", code: "c42944" },
  // { description: "injectable foam", code: "c113106" },
  // { description: "injectable, liposomal", code: "c60931" },
  { description: "injection", code: "c42946" },
  // { description: "injection, emulsion", code: "c42914" },
  // { description: "injection, lipid complex", code: "c42950" },
  // { description: "injection, powder, for solution", code: "c42974" },
  // { description: "injection, powder, for suspension", code: "c42976" },
  // { description: "injection, powder, for suspension, extended release", code: "c42977" },
  // { description: "injection, powder, lyophilized, for liposomal suspension", code: "c42959" },
  // { description: "injection, powder, lyophilized, for solution", code: "c42957" },
  // { description: "injection, powder, lyophilized, for suspension", code: "c42958" },
  // {
  //   description: "injection, powder, lyophilized, for suspension, extended release",
  //   code: "c42956",
  // },
  // { description: "injection, solution", code: "c42945" },
  // { description: "injection, solution, concentrate", code: "c42899" },
  // { description: "injection, suspension", code: "c42995" },
  // { description: "injection, suspension, extended release", code: "c42926" },
  // { description: "injection, suspension, liposomal", code: "c42951" },
  // { description: "injection, suspension, sonicated", code: "c42988" },
  // { description: "insert", code: "c60933" },
  // { description: "insert, extended release", code: "c42922" },
  // { description: "intrauterine device", code: "c47915" },
  // { description: "irrigant", code: "c42947" },
  // { description: "jelly", code: "c42948" },
  // { description: "kit", code: "c47916" },
  // { description: "liniment", code: "c42949" },
  // { description: "lipstick", code: "c42952" },
  // { description: "liquid", code: "c42953" },
  // { description: "liquid, extended release", code: "c60934" },
  // { description: "lotion", code: "c29167" },
  // { description: "lotion, augmented", code: "c60957" },
  // { description: "lotion/shampoo", code: "c60958" },
  // { description: "lozenge", code: "c42955" },
  // { description: "mouthwash", code: "c29269" },
  // { description: "not applicable", code: "c48624" },
  // { description: "oil", code: "c42965" },
  // { description: "ointment", code: "c42966" },
  // { description: "ointment, augmented", code: "c60984" },
  // { description: "paste", code: "c42967" },
  // { description: "paste, dentifrice", code: "c42907" },
  // { description: "pastille", code: "c60985" },
  // { description: "patch", code: "c42968" },
  // { description: "patch, extended release", code: "c42923" },
  // { description: "patch, extended release, electrically controlled", code: "c42911" },
  // { description: "pellet", code: "c42969" },
  // { description: "pellet, implantable", code: "c42943" },
  // { description: "pellets, coated, extended release", code: "c42918" },
  { description: "pill", code: "c25394" },
  // { description: "plaster", code: "c42970" },
  // { description: "poultice", code: "c47913" },
  // { description: "powder", code: "c42972" },
  // { description: "powder, dentifrice", code: "c42908" },
  // { description: "powder, for solution", code: "c42973" },
  // { description: "powder, for suspension", code: "c42975" },
  // { description: "powder, metered", code: "c42961" },
  // { description: "ring", code: "c60988" },
  // { description: "rinse", code: "c42979" },
  // { description: "salve", code: "c42980" },
  // { description: "shampoo", code: "c42981" },
  // { description: "shampoo, suspension", code: "c42982" },
  // { description: "soap", code: "c42983" },
  // { description: "solution", code: "c42986" },
  // { description: "solution, concentrate", code: "c42898" },
  // { description: "solution, for slush", code: "c42987" },
  // { description: "solution, gel forming / drops", code: "c60994" },
  // { description: "solution, gel forming, extended release", code: "c42935" },
  // { description: "solution/ drops", code: "c60992" },
  // { description: "sponge", code: "c47912" },
  // { description: "spray", code: "c42989" },
  // { description: "spray, metered", code: "c42962" },
  // { description: "spray, suspension", code: "c42990" },
  // { description: "stick", code: "c42991" },
  // { description: "strip", code: "c47914" },
  // { description: "suppository", code: "c42993" },
  // { description: "suppository, extended release", code: "c42924" },
  // { description: "suspension", code: "c42994" },
  // { description: "suspension, extended release", code: "c42925" },
  // { description: "suspension/ drops", code: "c60995" },
  // { description: "swab", code: "c47898" },
  // { description: "syrup", code: "c42996" },
  // { description: "system", code: "c17423" },
  { description: "tablet", code: "c42998" },
  // { description: "tablet, chewable", code: "c42893" },
  // { description: "tablet, chewable, extended release", code: "c124794" },
  // { description: "tablet, coated", code: "c42897" },
  // { description: "tablet, coated particles", code: "c60997" },
  // { description: "tablet, delayed release", code: "c42905" },
  // { description: "tablet, delayed release particles", code: "c42997" },
  // { description: "tablet, effervescent", code: "c42910" },
  // { description: "tablet, extended release", code: "c42927" },
  // { description: "tablet, film coated", code: "c42931" },
  // { description: "tablet, film coated, extended release", code: "c42930" },
  // { description: "tablet, for solution", code: "c61004" },
  // { description: "tablet, for suspension", code: "c61005" },
  // { description: "tablet, multilayer", code: "c42964" },
  // { description: "tablet, multilayer, extended release", code: "c42963" },
  // { description: "tablet, orally disintegrating", code: "c42999" },
  // { description: "tablet, orally disintegrating, delayed release", code: "c61006" },
  // { description: "tablet, soluble", code: "c42985" },
  // { description: "tablet, sugar coated", code: "c42992" },
  // { description: "tablet with sensor", code: "c147579" },
  // { description: "tampon", code: "c47892" },
  // { description: "tape", code: "c47897" },
  // { description: "tincture", code: "c43000" },
  // { description: "troche", code: "c43001" },
  // { description: "wafer", code: "c43003" },
];

export default medicationFormList;
